module.exports = __webpack_public_path__ + "static/media/layout-column.bae71a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/layout-column.png
// module id = 141
// module chunks = 0